<template>
  <v-card class="mt-2">
    <v-card-title>Vuokrasopimus</v-card-title>

    <v-container>
      <v-row class="contract-box" dense>
        <v-col cols="12" sm="6" md="4">
          <h4 class="mb-1">
            <strong>Sopimustiedot</strong>
          </h4>
          <p class="contract-text">Sopimusnumero</p>
          <p>{{ contract.contractNumber }}</p>

          <p class="contract-text">Vuokranantajat</p>
          <div v-for="landlord in contract.landlords" :key="landlord.name">
            <p>{{ landlord.name }}</p>
          </div>

          <p class="contract-text">Vuokrakohde</p>
          <p>
            {{ contract.apartment.address
            }}<span>{{
              contract.apartment.apartmentNumber ? `, ${contract.apartment.apartmentNumber}` : ""
            }}</span>
          </p>
          <p>{{ contract.apartment.zipCode }}, {{ contract.apartment.city }}</p>

          <div v-if="contract.contractType == 'new'">
            <p class="contract-text">Hinnat</p>
            <p>Vuokra: {{ contract.lease.rent }} €</p>
            <p>Vesimaksu: {{ contract.lease.waterChargePerMonth }} €</p>
            <p>Autopaikka: {{ contract.lease.parkingCost }} €</p>
            <p>Muut kustannukset: {{ contract.lease.otherCosts }}</p>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <h4 class="mb-1">
            <strong>Vuokralaiset</strong>
          </h4>
          <div v-for="(tenant, index) in contractTenants" :key="index + 'a'">
            <p class="contract-text">Vuokralainen {{ index + 1 }}</p>

            <p style="margin-bottom: 0px">
              {{ tenant.name }}
              <span v-if="tenant.revokedDate" :class="{ 'warning--text': tenant.revokedDate }"
                >(irtisanottu)</span
              >
            </p>

            <p style="margin-bottom: 0px" v-if="tenant.tenantId.email">
              {{ tenant.tenantId.email }}
            </p>

            <p v-if="tenant.tenantId.isCompany">
              {{ tenant.tenantId.businessId ? tenant.tenantId.businessId : "Ei y-tunnusta" }}
            </p>

            <p v-else>
              {{ tenant.tenantId.social ? tenant.tenantId.social : "Ei henkilötunnusta" }}
            </p>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <h4 class="mb-1">
            <strong>Vuokra-aika</strong>
          </h4>
          <p class="contract-text">Vuokrasopimuksen tyyppi</p>
          <p>{{ contract.lease.leaseType }}</p>
          <p class="contract-text">Vuokrasopimuksen alkamispäivä</p>
          <p>{{ formatDate(contract.lease.startDate) }}</p>
          <div v-if="contract.lease.endDate">
            <p class="contract-text">Vuokrasopimuksen päättymispäivä</p>
            <p>{{ formatDate(contract.lease.endDate) }}</p>
          </div>

          <div v-if="contract.contractType == 'new'">
            <div v-if="contract.lease.firstRentDate">
              <p class="contract-text">Vuokranmaksun alkamispäivä</p>
              <p>{{ formatDate(contract.lease.firstRentDate) }}</p>
            </div>
            <p class="contract-text">Vuokranmaksun eräpäivä</p>
            <p>{{ contract.lease.rentDueDate }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import mixins from "@/mixins/mixins";
import { getRentalContractTenants } from "@/utils/rentalContractHelpers";

export default {
  mixins: [mixins],

  props: ["contract"],

  computed: {
    contractTenants() {
      if (this.contract) {
        const tenants = getRentalContractTenants(this.contract);
        return tenants.map((el) => {
          if (el.tenantId) return el;
          else {
            return {
              ...el,
              tenantId: {},
            };
          }
        });
      }
      return [];
    },
  },
};
</script>

<style scoped>
p {
  font-size: 14px;
}

.contract-text {
  font-size: 14px;
  font-weight: 600;
  color: rgb(51, 51, 51);
}

.contract-box {
  max-width: 800px;
}
</style>
